import getUserLocale from 'get-user-locale';

const parseAvailableLocales = (locale: string) => {
    switch (locale) {
        case 'es':
            return 'es';
        default:
            return 'en';
    }
};

export const parseLocale = (): string => {
    let locale = getUserLocale();

    try {
        if (locale.includes('-') || locale.includes('_')) {
            if (locale.includes('-')) {
                [locale] = locale.split('-');
            } else {
                [locale] = locale.split('_');
            }

            return parseAvailableLocales(locale);
        }
        return parseAvailableLocales(locale);
    } catch (error) {
        locale = 'en';
        return parseAvailableLocales(locale);
    }
};
